import { Component, ChangeDetectionStrategy, inject, input, computed } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EditorialDepartment } from '../../../interfaces/editorial-department.interface';
import type { SalTeamGroup, StaffTeamRow } from '../../../interfaces/editorial-staff.interface';

@Component({
    selector: 'app-editorial-staff',
    templateUrl: './editorial-staff.component.html',
    styleUrls: ['./editorial-staff.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe]
})
export class EditorialStaffComponent {
    private readonly sanitizer = inject(DomSanitizer);

    public readonly editorialdepartment = input<EditorialDepartment[]>([]);

    teamsChatEndpoint = 'msteams://teams.microsoft.com/l/call/0/0?users=';

    protected readonly staffTeamRows = computed<StaffTeamRow[]>(() => {
        return this.editorialdepartment()
            .filter(person => person.name === 'SAL Redaktion' || person.name === 'SAL Editorial')
            .map(person => ({
                Abteilung: person.department,
                Standort: person.location,
                Email: person.email,
                Phone: person.phone ?? ''
            }));
    });

    protected readonly renderSalTeam = computed<SalTeamGroup[]>(() => {
        const positions: Record<string, EditorialDepartment[]> = {};

        this.editorialdepartment()
            .filter(person => person.name !== 'SAL Redaktion' && person.name !== 'SAL Editorial')
            .forEach(person => {
                const position = person.role || 'Unknown';
                if (!positions[position]) positions[position] = [];
                positions[position].push(person);
            });

        return Object.keys(positions).map(position => ({
            Position: position,
            rows: positions[position]
        }));
    });

    protected sanitize(url: string): SafeUrl {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}
